import React, { useCallback, useState, useEffect, useRef } from 'react';
import { IoTriangleSharp } from 'react-icons/io5';

import { RiGroupLine, RiWhatsappLine } from 'react-icons/ri';
import { BiCodeAlt, BiTargetLock } from 'react-icons/bi';
import { LuLightbulb } from 'react-icons/lu';

import { FaFigma } from 'react-icons/fa';
import { BsArrowUpRightCircleFill } from 'react-icons/bs';
import {
  Container,
  Hero,
  Highlight,
  AboutUs,
  Portfolio,
  Testimonials,
  OurServices,
  Faq,
} from './styles';

import bgHome from '~/assets/video/bg-home.mp4';
import blueDetail from '~/assets/defaults/blue-detail.svg';
import whiteDetail from '~/assets/defaults/white-detail.svg';
import appDev from '~/assets/defaults/app-dev.png';
import rectangle from '~/assets/defaults/rectangle.png';
import whiteFullLogo from '~/assets/logos/white-full-logo.svg';
import stars from '~/assets/defaults/star.svg';
import starsMobile from '~/assets/defaults/star-mobile.svg';
import wiserr from '~/assets/defaults/wiserr-macbook.png';
import koro from '~/assets/defaults/koro-sports.png';
import coi from '~/assets/defaults/coi-prime.png';
import fiariClean from '~/assets/logos/fiari-clean.svg';
import wiserrLogo from '~/assets/logos/wiserr.svg';
import duoUltimate from '~/assets/logos/duo-ultimate.svg';
import knarin from '~/assets/logos/knarin.svg';
import institutoBarueri from '~/assets/logos/instituto-barueri.svg';
import muove from '~/assets/logos/muove.svg';
import coiPrime from '~/assets/logos/coi-prime.svg';
import oticasCom from '~/assets/logos/oticas.com.svg';
import jayneMonteiro from '~/assets/logos/jayne-monteiro.svg';
import koroSports from '~/assets/logos/koro-sports.svg';
import david from '~/assets/defaults/david.png';
import pablo from '~/assets/defaults/pablo.png';
import jayne from '~/assets/defaults/jayne.png';
import augusto from '~/assets/defaults/augusto.png';

const Home: React.FC = () => {
  const aboutUsRef = useRef<HTMLDivElement>(null);
  const [returnTopActive, setReturnTopActive] = useState(false);
  const [question, setQuestion] = useState('');

  const handleScroll = useCallback(() => {
    const position = window.pageYOffset;
    if (aboutUsRef.current) {
      setReturnTopActive(position >= aboutUsRef.current.clientHeight);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  const handleClickQuestion = useCallback((questionData) => {
    setQuestion((state) => {
      if (state === questionData) {
        return '';
      }

      return questionData;
    });
  }, []);

  return (
    <Container returnTopActive={returnTopActive}>
      <Hero id="inicio" className="position-relative">
        <video
          muted
          autoPlay
          loop
          controls={false}
          className="position-absolute w-100 h-100"
        >
          <source src={bgHome} type="video/mp4" />
          <track kind="captions" />
        </video>
        <img
          src={blueDetail}
          alt="blue-detail"
          className="position-absolute blue-detail"
        />
        <img
          src={whiteDetail}
          alt="white-detail"
          className="position-absolute white-detail"
        />
        <div className="py-lg-5 container-xxl d-flex align-items-center vh-100 position-relative mb-5">
          <div className="container h-100">
            <div className="row align-items-end align-content-end h-100">
              <div className="col-lg-6 mb-5">
                <h1 className="h4 h1-sm display-xl-4 text-center text-lg-start">
                  <small className="normal-small fw-normal">
                    Na era <span>digital,</span>
                    <br /> destacar-se é essencial.
                  </small>
                </h1>
                <p className="h5-sm h4-xl fw-normal text-center text-lg-start">
                  <span className="small normal-small normal-sm">
                    Conte conosco para criar soluções únicas que{' '}
                    <br className="break-show d-md-block d-lg-none" />
                    potencializam sua presença online
                  </span>
                </p>
              </div>
              <div className="col-lg-6">
                <div className="highlight d-none d-lg-block">
                  <div>
                    <p className="mb-0 h6 h5-xl fw-light">
                      👋 Vamos moldar o futuro digital do seu negócio!
                    </p>
                  </div>
                </div>
                <div className="d-flex d-lg-none pb-5 mb-5 justify-content-center">
                  <a
                    href="https://api.whatsapp.com/send?phone=5511913096161&text=Ol%C3%A1!%20Gostaria%20de%20um%20or%C3%A7amento."
                    className="btn btn-budget py-3 px-4 mb-5 fs-sm-5"
                  >
                    Solicitar orçamento
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Hero>
      <Highlight>
        <div className="container">
          <div className="row">
            <div className="col-12 mt-5 mb-3 py-5">
              <h2 className="h6 fw-normal text-center">
                <span className="small normal-sm">DESTAQUE-SE</span>
              </h2>
              <h3 className="h5 h3-sm h1-lg text-center">
                Transforme Desafios em <br />
                Oportunidades Digitais
              </h3>
            </div>
            <div className="col-12 mb-5">
              <div className="dark-box position-relative">
                <div className="row">
                  <div className="col-sm-8">
                    <p className="h5 h4-sm h2-xl text-white mb-4 mb-xl-5 pe-lg-5">
                      Você enfrenta o desafio de uma presença online pouco
                      impactante, com um site desatualizado e uma ausência
                      significativa nas redes&nbsp;sociais?
                    </p>
                    <p className="text-gray fs-sm-5 mb-4 mb-xl-5">
                      Isso pode prejudicar seu alcance e deixar{' '}
                      <br className="d-none d-lg-block" />
                      potenciais clientes passarem despercebidos.
                    </p>
                    <p className="text-gray fs-sm-5">
                      E aqui na Devsigner, você encontra:
                      {/* um time de
                      especialistas prontos para transformar sua presença online
                      em uma verdadeira potência digital. */}
                    </p>
                  </div>
                </div>
                <img src={appDev} alt="app dev" className="position-absolute" />
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="bg-gray padding-small py-4 px-3 p-xl-5">
                <RiGroupLine
                  size={57}
                  color="#0075FF"
                  className="mt-lg-5 mb-4"
                />
                <p className="h5 h4-sm mb-4">
                  Equipe de <br className="d-none d-lg-block" /> especialistas
                </p>
                <p className="mb-0 small normal-sm pe-3">
                  Focados em desenvolvimento digital, prontos para transformar
                  sua presença online.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 my-4 my-md-0">
              <div className="bg-gray padding-small py-4 px-3 p-xl-5">
                <LuLightbulb
                  size={57}
                  color="#0075FF"
                  className="mt-lg-5 mb-4"
                />
                <p className="h5 h4-sm mb-4">
                  Equipe de <br className="d-none d-lg-block" /> criação
                </p>
                <p className="mb-0 small normal-sm pe-3">
                  Desde criação de um site até estratégias eficazes de mídia
                  social, oferecemos soluções integradas para sua visibilidade e
                  engajamento.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mt-md-4 mt-lg-0">
              <div className="bg-gray padding-small py-4 px-3 p-xl-5">
                <BiTargetLock
                  size={57}
                  color="#0075FF"
                  className="mt-lg-5 mb-4"
                />
                <p className="h5 h4-sm mb-4">
                  Alcance seu <br className="d-none d-md-block" /> público-alvo
                </p>
                <p className="mb-0 small normal-sm pe-3">
                  De forma eficiente e destaque-se na era digital com nossos
                  serviços abrangentes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Highlight>
      <AboutUs ref={aboutUsRef} id="quem-somos">
        <div className="container">
          <div className="row pb-5 py-lg-5">
            <div className="col-12 mt-5 mb-3 pt-5 py-lg-5">
              <h2 className="h6 fw-normal text-center">
                <span className="small normal-sm">SOBRE NÓS</span>
              </h2>
              <h3 className="h4 h3-sm h1-lg text-center">
                Conheça mais <br />
                sobre a Devsigner
              </h3>
            </div>
            <div className="col-12">
              <div className="position-relative mb-5">
                <img
                  src={rectangle}
                  alt="Detalhe"
                  className="w-100 rectangle"
                />
                <img
                  src={whiteFullLogo}
                  alt="Devsigner Systems"
                  className="position-absolute logo"
                />
                <div className="position-absolute d-flex align-items-center code-design">
                  <div className="rounded-circle bg-dark-gray me-2">
                    <BiCodeAlt size={44} color="#fff" />
                  </div>
                  <div className="rounded-circle bg-dark-gray">
                    <FaFigma size={44} color="#fff" />
                  </div>
                </div>
              </div>
            </div>
            <div className="co-lg-6">
              <p className="fs-md-5 fs-lg-4 pe-lg-4">
                Somos uma empresa especializada no desenvolvimento de projetos
                digitais de alta performance, com foco em usabilidade e
                conversão.
              </p>
            </div>
            <div className="co-lg-6">
              <p className="fs-md-5 fs-lg-4 pe-lg-4">
                Reunimos profissionais criativos, qualificados e com anos de
                experiência para garantirmos excelência em cada etapa
                do&nbsp;projeto.
              </p>
            </div>
          </div>
        </div>
      </AboutUs>
      <Portfolio>
        <div className="container">
          <div className="row">
            <div className="col-12 mt-5 mb-3 py-lg-5">
              <h2 className="h6 fw-normal text-center">
                <span className="small normal-sm">PORTIFOLIO</span>
              </h2>
              <h3 className="h4 h3-sm h1-lg text-center">Clientes Devsigner</h3>
            </div>
            <a
              href="https://wiserr.io"
              className="col-md-4"
              target="_blank"
              rel="noreferrer"
            >
              <div className="highlight">
                <img src={wiserr} alt="Wiserr" />
                <div className="d-flex justify-content-between align-items-center py-4 px-3">
                  <p className="mb-0 h4">Wiserr</p>
                  <BsArrowUpRightCircleFill size={34} color="#000" />
                </div>
              </div>
            </a>
            <a
              href="https://koro.com.br"
              className="col-md-4 my-4 my-md-0"
              target="_blank"
              rel="noreferrer"
            >
              <div className="highlight">
                <img src={koro} alt="Koro Sports" />
                <div className="d-flex justify-content-between align-items-center py-4 px-3">
                  <p className="mb-0 h4">Koro Sports</p>
                  <BsArrowUpRightCircleFill size={34} color="#000" />
                </div>
              </div>
            </a>
            <a
              href="https://coiprime.com.br"
              className="col-md-4"
              target="_blank"
              rel="noreferrer"
            >
              <div className="highlight">
                <img src={coi} alt="COI Prime" />
                <div className="d-flex justify-content-between align-items-center py-4 px-3">
                  <p className="mb-0 h4">COI Prime</p>
                  <BsArrowUpRightCircleFill size={34} color="#000" />
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className="rolling-wrapper py-5">
          <div className="rolling-track">
            <a
              href="https://fiariclean.com.br"
              target="_blank"
              rel="noreferrer"
            >
              <img src={fiariClean} alt="Fiari Clean" />
            </a>
            <a href="https://wiserr.io" target="_blank" rel="noreferrer">
              <img src={wiserrLogo} alt="Wiserr" />
            </a>
            <a
              href="https://duoultimate.com.br"
              target="_blank"
              rel="noreferrer"
            >
              <img src={duoUltimate} alt="Duo Ultimate" />
            </a>
            <a
              href="/#"
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.preventDefault()}
            >
              <img src={knarin} alt="Knarin" />
            </a>
            <a
              href="https://institutobarueri.org.br"
              target="_blank"
              rel="noreferrer"
            >
              <img src={institutoBarueri} alt="Instituto Barueri" />
            </a>
            <a href="https://muove.com.br" target="_blank" rel="noreferrer">
              <img src={muove} alt="Muove" />
            </a>
            <a href="https://coiprime.com.br" target="_blank" rel="noreferrer">
              <img src={coiPrime} alt="Coi Prime" />
            </a>
            <a
              href="/#"
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.preventDefault()}
            >
              <img src={oticasCom} alt="Oticas.Com" />
            </a>
            <a
              href="/#"
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.preventDefault()}
            >
              <img src={jayneMonteiro} alt="Jayne Monteiro" />
            </a>
            <a href="https://koro.com.br" target="_blank" rel="noreferrer">
              <img src={koroSports} alt="Koro Sports" />
            </a>
            <a
              href="https://fiariclean.com.br"
              target="_blank"
              rel="noreferrer"
            >
              <img src={fiariClean} alt="Fiari Clean" />
            </a>
            <a href="https://wiserr.io" target="_blank" rel="noreferrer">
              <img src={wiserrLogo} alt="Wiserr" />
            </a>
            <a
              href="https://duoultimate.com.br"
              target="_blank"
              rel="noreferrer"
            >
              <img src={duoUltimate} alt="Duo Ultimate" />
            </a>
            <a
              href="/#"
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.preventDefault()}
            >
              <img src={knarin} alt="Knarin" />
            </a>
            <a
              href="https://institutobarueri.org.br"
              target="_blank"
              rel="noreferrer"
            >
              <img src={institutoBarueri} alt="Instituto Barueri" />
            </a>
            <a href="https://muove.com.br" target="_blank" rel="noreferrer">
              <img src={muove} alt="Muove" />
            </a>
            <a href="https://coiprime.com.br" target="_blank" rel="noreferrer">
              <img src={coiPrime} alt="Coi Prime" />
            </a>
            <a
              href="/#"
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.preventDefault()}
            >
              <img src={oticasCom} alt="Oticas.Com" />
            </a>
            <a
              href="/#"
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.preventDefault()}
            >
              <img src={jayneMonteiro} alt="Jayne Monteiro" />
            </a>
            <a href="https://koro.com.br" target="_blank" rel="noreferrer">
              <img src={koroSports} alt="Koro Sports" />
            </a>
            <a
              href="https://fiariclean.com.br"
              target="_blank"
              rel="noreferrer"
            >
              <img src={fiariClean} alt="Fiari Clean" />
            </a>
            <a href="https://wiserr.io" target="_blank" rel="noreferrer">
              <img src={wiserrLogo} alt="Wiserr" />
            </a>
            <a
              href="https://duoultimate.com.br"
              target="_blank"
              rel="noreferrer"
            >
              <img src={duoUltimate} alt="Duo Ultimate" />
            </a>
          </div>
        </div>
      </Portfolio>
      <Testimonials>
        <div className="container">
          <div className="row">
            <div className="col-12 mt-5 mb-3 py-lg-5">
              <h2 className="h6 fw-normal text-center">
                <span className="small normal-sm">DEPOIMENTOS</span>
              </h2>
              <h3 className="h4 h3-sm h1-lg text-center">
                O que nossos <br className="d-md-none" />
                clientes dizem
              </h3>
            </div>
            <div className="col-sm-6 col-xl-3 mb-4 mb-xl-0">
              <div className="box">
                <div className="d-flex align-items-center mb-3">
                  <img src={david} alt="David Motta" className="avatar" />
                  <p className="h5 mb-0 ms-2">David Motta</p>
                </div>
                <p>
                  Nossa vocês conseguiram fazer o que ninguém conseguiu, deixar
                  meu sistema idêntico ao layout, vocês são os melhores!
                </p>
              </div>
            </div>
            <div className="col-sm-6 col-xl-3 mb-4 mb-xl-0">
              <div className="box">
                <div className="d-flex align-items-center mb-3">
                  <img src={pablo} alt="Pablo" className="avatar" />
                  <p className="h5 mb-0 ms-2">Pablo</p>
                </div>
                <p>Muito obrigado. Adorei o trabalho de vocês</p>
              </div>
            </div>
            <div className="col-sm-6 col-xl-3 mb-4 mb-sm-0">
              <div className="box">
                <div className="d-flex align-items-center mb-3">
                  <img src={jayne} alt="Jayne" className="avatar" />
                  <p className="h5 mb-0 ms-2">Jayne</p>
                </div>
                <p>
                  Amei a experiência de ter minha marca desenvolvida por vocês!!
                  Não poderia ter escolhido melhor! 🥰🤩
                </p>
              </div>
            </div>
            <div className="col-sm-6 col-xl-3">
              <div className="box">
                <div className="d-flex align-items-center mb-3">
                  <img src={augusto} alt="Augusto" className="avatar" />
                  <p className="h5 mb-0 ms-2">Augusto</p>
                </div>
                <p>
                  Vocês são feras, muito bom ver meu projeto saindo do papel!
                  🤜🏻🤛🏻
                </p>
              </div>
            </div>
          </div>
        </div>
      </Testimonials>
      <OurServices id="solucoes" className="position-relative pt-5">
        <div className="container py-5">
          <div className="row pt-5">
            <div className="col-12 pt-5">
              <div className="blue-box position-relative px-4 px-lg-5 pb-3">
                <div className="row box position-relative mx-xl-4 py-5 px-lg-5">
                  <div className="col-lg-6 pt-4 pt-xl-5 d-flex flex-column justify-content-center align-items-center align-items-lg-start">
                    <h2 className="h4 h3-lg h1-lg text-primary text-center text-lg-start mt-5 mt-lg-0">
                      Ao escolher nossos serviços...
                    </h2>
                    <p className="fs-lg-5 mt-4 mb-3 mb-lg-5 text-center text-lg-start">
                      Você garante uma abordagem profissional,{' '}
                      <br className="break-show" />
                      personalizada e benefícios exclusivos.
                    </p>
                    <a
                      href="https://api.whatsapp.com/send?phone=5511913096161&text=Ol%C3%A1!%20Gostaria%20de%20iniciar%20um%20projeto."
                      className="btn btn-primary p-3 fw-medium"
                    >
                      Começar um serviço
                    </a>
                  </div>
                  <img
                    src={starsMobile}
                    alt="stars"
                    className="position-absolute starts d-block d-lg-none"
                  />
                  <img
                    src={stars}
                    alt="stars"
                    className="position-absolute starts pe-0 d-none d-lg-block"
                  />
                </div>
                <p className="h5 h3-lg h2-xl mt-n5 mt-lg-n3 mb-4">
                  Iniciando seu projeto conosco, proporcionamos{' '}
                  <br className="d-none d-lg-block" />
                  consultoria personalizada sem custos iniciais
                </p>
                <p className="fs-5 fs-lg-3 fs-xl-2 mb-5">
                  análise detalhada de suas necessidades digitais e entrega{' '}
                  <br className="d-none d-lg-block" />
                  ágil para ativar sua presença online rapidamente.
                </p>
              </div>
            </div>
          </div>
        </div>
      </OurServices>
      <Faq>
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-6">
              <h2 className="h5 fw-normal">Perguntas frequentes</h2>
              <h3 className="h2 fw-semibold text-primary my-4">FAQ</h3>
              <p className="h5-lg fw-normal text-secondary mb-4 mb-lg-5 pb-lg-5 pt-lg-5">
                Para orçamentos e dúvidas, entre em{' '}
                <br className="d-none d-lg-block" />
                contato conosco. Estamos á disposição{' '}
                <br className="d-none d-lg-block" />
                para atendê-lo da melhor forma possível.
              </p>
              <a
                href="https://api.whatsapp.com/send?phone=5511913096161&text=Ol%C3%A1!%20Estou%20com%20d%C3%BAvidas%20pode%20me%20ajudar?"
                className="rounded-pill px-3 py-2 d-none d-lg-flex align-items-center justify-content-center"
                target="_blank"
                rel="noreferrer"
              >
                <span>
                  <RiWhatsappLine size={20} color="#FFFFFF" />
                </span>
                <span>
                  Alguma dúvida? <b>Contate-nos</b>
                </span>
              </a>
            </div>
            <div className="col-lg-6">
              <div className="question">
                <button
                  type="button"
                  className={`btn btn-faq d-flex align-items-center w-100 text-start ${
                    question === 'Qual o prazo de entrega?' ? 'opened' : ''
                  }`}
                  onClick={() =>
                    handleClickQuestion('Qual o prazo de entrega?')
                  }
                >
                  <IoTriangleSharp
                    size={21}
                    color="#ADCEF4"
                    className="ms-2 me-3"
                  />
                  <span>Qual o prazo de entrega?</span>
                </button>
                <div
                  className={`answer ${
                    question === 'Qual o prazo de entrega?' ? 'opened' : ''
                  }`}
                >
                  <div
                    className={`p-4 ${
                      question === 'Qual o prazo de entrega?' ? 'opened' : ''
                    }`}
                  >
                    <p>
                      Depende muito do produto que deseja, mas para o caso de
                      uma landpage, pode-se entregar em até um mês.
                    </p>
                  </div>
                </div>
              </div>
              <div className="question my-3">
                <button
                  type="button"
                  className={`btn btn-faq d-flex align-items-center w-100 text-start ${
                    question ===
                    'Qual ferramenta utiliza para desenvolver as paginas?'
                      ? 'opened'
                      : ''
                  }`}
                  onClick={() =>
                    handleClickQuestion(
                      'Qual ferramenta utiliza para desenvolver as paginas?'
                    )
                  }
                >
                  <IoTriangleSharp
                    size={21}
                    color="#ADCEF4"
                    className="ms-2 me-3"
                  />
                  <span>
                    Qual ferramenta utiliza para desenvolver as paginas?
                  </span>
                </button>
                <div
                  className={`answer ${
                    question ===
                    'Qual ferramenta utiliza para desenvolver as paginas?'
                      ? 'opened'
                      : ''
                  }`}
                >
                  <div className="p-4">
                    <p>
                      No caso de programação, usa-se React, React-Native,
                      Node.Js, PHP, entre outros.
                    </p>
                    <p>
                      Em casos de Design, usamos Figma, Adobe XD, Photoshop,
                      entre outros.
                    </p>
                  </div>
                </div>
              </div>
              <div className="question mb-3">
                <button
                  type="button"
                  className={`btn btn-faq d-flex align-items-center w-100 text-start ${
                    question === 'Preciso ter domínio e hospedagem?'
                      ? 'opened'
                      : ''
                  }`}
                  onClick={() =>
                    handleClickQuestion('Preciso ter domínio e hospedagem?')
                  }
                >
                  <IoTriangleSharp
                    size={21}
                    color="#ADCEF4"
                    className="ms-2 me-3"
                  />
                  <span>Preciso ter domínio e hospedagem?</span>
                </button>
                <div
                  className={`answer ${
                    question === 'Preciso ter domínio e hospedagem?'
                      ? 'opened'
                      : ''
                  }`}
                >
                  <div className="p-4">
                    <p>
                      Sim, é necessário ter um domínio para ter um site online.
                      Podemos cuidar de todo o processo de gerenciamento e
                      contratação do domínio para você, arcando apenas com os
                      custos do domínio. Assim, seu site estará sempre acessível
                      na internet.
                    </p>
                  </div>
                </div>
              </div>
              <div className="question">
                <button
                  type="button"
                  className={`btn btn-faq d-flex align-items-center w-100 text-start ${
                    question === 'As paginas sao otimizadas e responsivas?'
                      ? 'opened'
                      : ''
                  }`}
                  onClick={() =>
                    handleClickQuestion(
                      'As paginas sao otimizadas e responsivas?'
                    )
                  }
                >
                  <IoTriangleSharp
                    size={21}
                    color="#ADCEF4"
                    className="ms-2 me-3"
                  />
                  <span>As paginas sao otimizadas e responsivas?</span>
                </button>
                <div
                  className={`answer ${
                    question === 'As paginas sao otimizadas e responsivas?'
                      ? 'opened'
                      : ''
                  }`}
                >
                  <div className="p-4">
                    <p>Sim! No caso de sites, sistemas, landpage, etc.</p>
                    <p>São adaptáveis para todos dispositvos e navegadores</p>
                  </div>
                </div>
              </div>
              <a
                href="https://api.whatsapp.com/send?phone=5511913096161&text=Ol%C3%A1!%20Estou%20com%20d%C3%BAvidas%20pode%20me%20ajudar?"
                className="rounded-pill px-3 py-2 d-flex align-items-center justify-content-center d-block d-lg-none mt-4"
                target="_blank"
                rel="noreferrer"
              >
                <span>
                  <RiWhatsappLine size={13} color="#FFFFFF" />
                </span>
                <span>
                  Alguma dúvida? <b>Contate-nos</b>
                </span>
              </a>
            </div>
          </div>
        </div>
      </Faq>
    </Container>
  );
};

export default Home;
